

import {Component, Prop, Vue} from "vue-property-decorator";
import { NavigationLink } from "@/types/NavigationLinks.ts";
import LocaleSwitcher from "@/components/layout/LocaleSwitcher.vue";

@Component({
  components: {LocaleSwitcher}
})
export default class NavigationBar extends Vue {

  @Prop()
  links!: Array<NavigationLink>;

  constructor() {
    super();
  }

  pathToPics = require.context('@/assets/', false, /\.[svjpn]{2}g$/);

  getPic(name: string): string {
    return this.pathToPics('./'.concat(name))
  }

}
